import { ClientGate } from '@elements/client-gate'
import { withDateFormat } from '@utils/date-time'
import { nthNumber } from '@utils/strings'
import { useMemo } from 'react'
import { AdmissionGroup } from 'types/model/admission-group'

export function GuestlistConfirmationCopy({
  status,
  date,
}: {
  status: AdmissionGroup['status']
  date: string
}) {
  const dateString = useMemo(
    () =>
      `${withDateFormat(date, 'cccc LLLL d')}${nthNumber(
        new Date(date).getDate()
      )}, ${withDateFormat(date, 'yyyy')}`,
    [date]
  )

  return status === 'CONFIRMED' ? (
    <div className='flex flex-row items-start justify-start space-x-2'>
      <span className='text-lg'>☑️</span>
      <div className='pt-1 space-y-3 '>
        <p>
          You are confirmed for <ClientGate>{dateString}</ClientGate>
        </p>
        <p>We sent you an email containing your guestlist confirmation</p>
      </div>
    </div>
  ) : (
    <div className='space-y-3'>
      <p>
        Thanks for submitting your request for{' '}
        <ClientGate>{dateString}</ClientGate>
      </p>
      <p>
        Your information has been sent to our managers. You should be receiving
        a call or email from them soon.
      </p>
    </div>
  )
}
